// Single source of truth for role labels + hierarchy across the frontend.
// Keep in sync with backend `models.py: ROLE_LEVELS`.

export const ROLE_LEVELS = {
  super_owner: 5,
  owner: 4,
  admin: 3,
  locatie: 2,
  kluisbeheer: 1,
};

export const ROLE_LABELS = {
  super_owner: 'Super Owner',
  owner: 'Owner',
  admin: 'Admin',
  locatie: 'Locatie',
  kluisbeheer: 'Kluisbeheer',
};

export function roleLabel(slug) {
  return ROLE_LABELS[slug] || slug || '';
}

export function roleLevel(slug) {
  return ROLE_LEVELS[slug] || 0;
}
